import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import ReactTable from 'react-table'
import { _delete, get, patch } from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError } from "../../../server/util";

class Schools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            schoolList: [],
            searchedSchool: [],
            search: '',
            schoolType: 'all',
            typeCode: [],
            schoolName: [],
            statusCode: [],
            adminUsers: []

        }
    }
    AddSchool = () => {
        this.context.router.history.push('/superAdmin/schoolRecord/0')

    }
    componentWillMount = () => {
        this.getSchoolList();
        // loggedUser = sessionStorage.getItem('loggedInUserInfo') || '';
    };
    filterSchool = () => {
        let searchedSchool = [];
        let s = this.state.search;
        console.log("scholl s:::::::", s);
        if (s.length > 0) {
            this.state.schoolList.forEach(obj => {
                console.log("school obj::::::", obj);
                if ((obj.id).startsWith(s)) {
                    searchedSchool.push(obj);
                } else if (obj.schoolName != null && (obj.schoolName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.county != null && (obj.county.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.schoolAddress != null && (obj.schoolAddress.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.telephone != null && (obj.telephone.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            this.setState({ searchedSchool: searchedSchool });
        }

        else {
            this.setState({ searchedSchool: this.state.schoolList });
        }
    };
    getSchoolList = () => {
        get('/schools?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            /* let protocal = "https://";
            let mainDomain = "mealmanage.com";
            console.log('SchoolList', this.state.schoolList); */
            const _schools = data._embedded.schools.map(obj => {
                obj.id = obj._links.self.href.split('/').pop();
                return obj;
            })
            this.setState({
                schoolList: _schools
            }, () => {
                this.filterSchool();
            });
            console.log('SchoolList', this.state.schoolList);
        })
            .catch(
                (error) => {
                    console.log('Get SchoolList response', error)
                }
            )
    };
    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                        <h2>
                            <span>Schools</span>
                        </h2>
                    </div>

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <input type="text" className="form-control" value={this.state.search}
                                name="search" placeholder="Search.." onChange={(e) => {
                                    this.setState({ search: e.target.value }, () => {
                                        this.filterSchool()
                                    })
                                }} autoComplete="off" />
                        </div>
                        <div className="col-md-2 form-group" >
                            {/* <select className="form-control" name="schoolType" value={this.state.schoolType} onChange={(e)=>{
                                this.setState({schoolType:e.target.value},()=>{
                                    this.filterSchool();
                                })
                            }}>
                                <option value="all">All</option>
                                <option value="Onboard">Onboard</option>
                                <option value="notOnboard">Not Onboard</option>
                            </select> */}
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 button-group-section form-group">
                            <button className="btn btn-success button-sm add-btn-sm"
                                id="addSchool" onClick={() => { this.AddSchool() }}>
                                <i className="fa fa-plus" /> Add School</button>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <ReactTable
                                data={this.state.searchedSchool}
                                columns={[{
                                    Header: 'School Id',
                                    accessor: 'id',
                                    width: 100,
                                    style: { textAlign: 'center' },
                                },

                                {
                                    Header: "SCHOOL NAME", width: 250, style: { textAlign: 'center' },
                                    Cell: (props) => {
                                        return <span ><Link to={`/superAdmin/schoolRecord/${props.original.id}`} className="text-info"
                                        >{props.original.schoolName}</Link></span>
                                    }
                                },
                                { Header: "SCHOOL ADDRESS", width: 150, accessor: "schoolAddress", style: { textAlign: 'center' } },
                                { Header: "COUNTY", width: 100, accessor: "countryCode", style: { textAlign: 'center' } },
                                { Header: "TELEPHONE", width: 100, accessor: "telephone", style: { textAlign: 'center' } },
                                { Header: "Type Of School", width: 150, accessor: "typeOfSchool.type", style: { textAlign: 'center' } },
                                { Header: "Type Of Schools By Grade", width: 150, accessor: "typeOfSchoolByGrade.type", style: { textAlign: 'center' } },
                                { Header: "Meal Eligibility Program", width: 150, accessor: "mealEligibilityProgram.program", style: { textAlign: 'center' }, },
                                { Header: "School Information System", width: 150, accessor: "schoolInformationSystem.type", style: { textAlign: 'center' } },
                                { Header: "ACTION", width: 100 }
                                ]}
                                defaultPageSize={10}
                                className="-striped -highlight rtTable-Order"
                                noDataText='No data found'
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
Schools.contextTypes = {
    router: PropTypes.object.isRequired
}
export default Schools;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Schools/index.jsx